import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import AuthService from '../../../services/auth.service';
export const signup = createAsyncThunk('auth/register', async (attr) => {
    try {
        return await AuthService.signup(attr);
    }
    catch (err) {
        return err.response;
    }
});
export const confirmEmail = createAsyncThunk('auth/confirm', async (token) => {
    try {
        return await AuthService.confirm(token);
    }
    catch (err) {
        return err.response;
    }
});
export const initialState = {
    email: '',
    error: null,
    isDataSend: false,
    emailConfirmed: null,
    pending: false
};
export const slice = createSlice({
    name: 'signup',
    initialState,
    reducers: {
        clearData: (state) => {
            state.error = null;
            state.isDataSend = false;
            state.emailConfirmed = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(signup.fulfilled, (state, action) => {
            state.pending = false;
            if (action.payload.status === 200) {
                state.isDataSend = true;
            }
            else {
                state.error = action.payload.data.details;
            }
        });
        builder.addCase(signup.rejected, (state, action) => {
            state.isDataSend = false;
            state.error = action.error.message;
            state.pending = false;
        });
        builder.addCase(signup.pending, (state) => {
            state.error = null;
            state.isDataSend = false;
            state.pending = true;
        });
        builder.addCase(confirmEmail.fulfilled, (state, action) => {
            if (action.payload.status === 200) {
                state.emailConfirmed = true;
            }
            if (action.payload.status === 409) {
                state.emailConfirmed = false;
                state.error = action.payload.data.error;
            }
            if (action.payload.status === 404) {
                state.emailConfirmed = false;
                state.error = action.payload.data.error;
            }
            if (action.payload.status === 400) {
                state.emailConfirmed = false;
                state.error = action.payload.data.details;
            }
        });
        builder.addCase(confirmEmail.pending, (state) => {
            state.emailConfirmed = null;
            state.error = null;
        });
        builder.addCase(confirmEmail.rejected, (state, action) => {
            state.emailConfirmed = false;
            state.error = action.error.message;
        });
    }
});
export const { clearData } = slice.actions;
export default slice.reducer;
